import { ComponentProps, useRef } from "react";
import { useMatch, useSearchParams } from "react-router-dom";
import { SplatPage, getMFEConfig } from "@sunrun/sales-experience-shared";
import { useIframeMessages, useSynchronizeUrl } from "./common";
import type { IFrame } from "components/atoms/IFrame";
import { Message } from "messages";

const useSplatAdapter = (
  page: SplatPage,
  localMessageHandler?: (message: Message | undefined) => Message | undefined
): ComponentProps<typeof IFrame> => {
  let [searchParams] = useSearchParams();
  const ref = useRef<HTMLIFrameElement | null>(null);
  const config = getMFEConfig("splat", page);
  const basePath = config.iFrameUrl;
  const match = useMatch(`/${config.containerPath}/*`);
  const src = `${basePath}/${match?.params["*"] ?? ""}?${searchParams}`;
  const { staticSrc } = useSynchronizeUrl(ref, src, basePath);
  useIframeMessages(
    ref,
    "Legacy Splat",
    config.containerPath,
    localMessageHandler
  );
  return {
    ref,
    basePath: basePath,
    src: staticSrc,
    title: config.title,
  };
};

export { useSplatAdapter };
